import { DateValueEstimate } from '@chiroup/core/types/Survey.type';
import React from 'react';
import { InlineListBox } from './InlineListBox';

type Props = {
  value: DateValueEstimate;
  onChange: (val: DateValueEstimate) => void;
  primaryColor: string;
  language?: string;
  size?: 'normal' | 'small';
};

const DatepickerEstimate: React.FC<Props> = ({
  value,
  onChange,
  primaryColor,
  language,
  size = 'normal',
}) => {
  const onChangeValue = (val: number) => {
    onChange({ ...value, value: val });
  };

  const onChangeUnit = (val: string) => {
    onChange({ ...value, unit: val });
  };

  const isSmall = size === 'small';
  const padding = isSmall ? 'mb-2 p-3' : 'mb-4 p-6';
  const promptTextSize = isSmall ? 'text-sm' : 'text-lg sm:text-xl';
  const mainTextSize = isSmall
    ? 'text-xl font-bold'
    : 'text-4xl tracking-tight leading-10 font-extrabold sm:text-5xl sm:leading-none md:text-6xl lg:text-5xl xl:text-6xl';

  console.log('value', value);

  return (
    <div className={padding}>
      <p className={`text-gray-500 ${promptTextSize}`}>
        {language === 'es' ? 'Dinos tu mejor estimado:' : 'Give us your best guess:'}
      </p>
      <div className={`text-gray-900 ${mainTextSize}`}>
        {language === 'es' ? 'Hace ' : 'About '}
        <InlineListBox
          value={value.value}
          onChange={onChangeValue}
          options={Array.from(Array(30)).map((item, i) => i + 1)}
          className="w-64"
          primaryColor={primaryColor}
        />{' '}
        <InlineListBox
          options={['day', 'week', 'month', 'year']}
          value={value.unit}
          onChange={onChangeUnit}
          suffix={value.value > 1 ? 's' : ''}
          primaryColor={primaryColor}
        />
        {language === 'es' ? ' atras.' : ' ago.'}
      </div>
    </div>
  );
};

export default DatepickerEstimate;
